import { Chip, useTheme } from "@mui/material";
import { AssignmentStatus, statusToThemeKey } from "../../api/assignments/assignment";

interface AssignmentStatusChipProps {
	status: AssignmentStatus;
	label: string;
}

/**
 * A role's current standing, named and coloured the way assignment status is
 * coloured everywhere else in ODI.
 *
 * @example
 * <AssignmentStatusChip status={AssignmentStatus.DONE_FAILED} label="Lost" />
 */
export const AssignmentStatusChip = ({ status, label }: AssignmentStatusChipProps) => {
	const theme = useTheme();

	return (
		<Chip
			size="small"
			label={label}
			sx={{
				height: 22,
				backgroundColor:
					theme.assignmentStatus[statusToThemeKey[AssignmentStatus[status]]],
				color: "common.black",
			}}
			data-component="assignment-status-chip"
		/>
	);
};
